function buildIntroHtml(productContent) {
  const slide = productContent.overview[0];
  const { name, secondName } = productContent.info;

  const subsectionsHtml = slide.subsections
    .map(
      s => `
                    <li class="product-details-html-list-item">
                        <strong class="product-details-html-list-title">${s.title}</strong>
                        <span class="product-details-html-list-text">
                            ${s.text}
                        </span>
                    </li>`
    )
    .join("");

  return `
               <div class="product-details-html-title-container">
                    <div class="product-details-html-title-second-title">
                        <div class="product-details-html-title">${name}</div>
                        <div class="product-details-html-second-title">${secondName}</div>
                    </div>
                </div>
                <p class="product-details-html-description">
${slide.introDescription}
                </p>
                <p class="product-details-html-sections-intro">
                    ${slide.sectionsIntro}
                </p>
                <ul class="product-details-html-list">${subsectionsHtml}
                </ul>
                <p class="product-details-html-conclusion">
                    ${slide.conclusion}
                </p>
              `;
}

function buildOverviewSlideHtml(slide) {
  const paragraphs = slide.paragraphs
    .map(p => `<p class="overview-2-description">\n${p}\n                </p>`)
    .join("\n                ");

  return `
                <div class="overview-2-title-container">
                  <div class="overview-2-title">${slide.heading}</div>
                </div>
                ${paragraphs}
              `;
}

function buildSectionHtml(section) {
  let html = `
             <div class="section-custom-title-container">
                  <div class="section-custom-title">${section.title}</div>
                </div>
                <p class="section-custom-description">
${section.description}
</p>`;

  if (section.descriptionExtra) {
    html += `
<p class="section-custom-description">
${section.descriptionExtra}
</p>`;
  }

  return html;
}

function buildHtmlList(items) {
  const lis = items.map(item => `<li>${item}</li>`).join("\n                  ");
  return `
                <ul class="overview-list-features">
                  ${lis}
                </ul>
              `;
}

export function buildBoxContents(productContent, isMobile) {
  const { info, overview, sections, photos, videos, features, specifications } = productContent;

  const overviewSlides = overview.map((slide, idx) => ({
    id: idx + 1,
    index: idx,
    title: info.name,
    secondTitle: info.secondName,
    image: slide.image,
    details: idx === 0 ? buildIntroHtml(productContent) : buildOverviewSlideHtml(slide),
  }));

  const sectionSlides = sections.map((section, idx) => ({
    id: idx + 1,
    index: idx,
    title: "SECTIONS",
    secondTitle: "",
    image: section.image,
    details: buildSectionHtml(section),
  }));

  const boxContents0 = isMobile ? [...overviewSlides, ...sectionSlides] : overviewSlides;

  const boxContents1 = [
    {
      id: 1,
      index: 1,
      title: "photo",
      secondTitle: "",
      image: photos.desktop[0],
      details: "photo",
      images: isMobile ? photos.mobile : photos.desktop,
    },
  ];

  const boxContents2 = sectionSlides;

  const boxContents3 = [
    {
      id: 1,
      index: 3,
      title: "video",
      secondTitle: "",
      image: overview[0].image,
      details: "video",
      videos: videos.map(v => ({
        videoUrl: v.url,
        isYouTubeVideo: v.isYouTube,
      })),
    },
  ];

  const boxContents4 = [
    {
      id: 1,
      index: 4,
      title: "details",
      secondTitle: "",
      image: overview[0].image,
      details: "details",
      sections: {
        features: buildHtmlList(features),
        specifications: buildHtmlList(specifications),
        manuals: "Here are the manuals for the details folder...",
      },
    },
  ];

  return [boxContents0, boxContents1, boxContents2, boxContents3, boxContents4, []];
}
